import React, { useEffect } from 'react';

// assets

// services

// props

// components
import { Checkbox, DefaultButton, Panel, PanelType, PrimaryButton, Stack } from '@fluentui/react';
import Label from '../../../typography/label';
import { AdvancedFilterProps } from '.';

type IncomesDashboardFilterProps = {
    filters?: AdvancedFilterProps[];
    onDismiss(filters?: AdvancedFilterProps[]): void;
}

export type FilterOptionProps = {
    id: string;
    text: string;
    data: any;
}

const IncomesDashboardFilter: React.FC<IncomesDashboardFilterProps> = (props: IncomesDashboardFilterProps) => {
    const [filters, setFilters] = React.useState<AdvancedFilterProps[]>(props.filters || []);

    useEffect(() => {
    }, []);

    const renderFilter = (key: string, title: string, options: FilterOptionProps[]) => {
        const filter = filters.find((f) => f.key === key);
        const uniqueOptions = options.filter((option, index, self) => index === self.findIndex((u) => u.id === option.id));

        return <Stack tokens={{ childrenGap: 10 }}>
            <Label>{title}</Label>
            <Stack tokens={{ childrenGap: 10 }} styles={{ root: { maxHeight: 250, overflowY: 'auto' } }}>
                {uniqueOptions.map((opt) => {
                    const isChecked = (filter?.selected || []).findIndex((s) => s.id === opt.id) > -1;
                    return <Checkbox label={opt.text} checked={isChecked} onChange={(ev, checked) => {
                        let _filters = filters;
                        const fidx = _filters.findIndex((f) => f.key === key);

                        if (fidx > -1) {
                            const sidx = _filters[fidx].selected.findIndex((s) => s.id === opt.id);
                            if (checked && sidx < 0) {
                                _filters[fidx].selected.push(opt);
                            } else if (!checked && sidx > -1) {
                                _filters[fidx].selected.splice(sidx, 1);
                            }
                        } else if (fidx < 0 && checked) {
                            _filters.push({
                                key,
                                title,
                                selected: [opt]
                            });
                        }

                        setFilters([..._filters]);
                    }} />
                })}
            </Stack>
        </Stack>;
    }

    return <Panel headerText={'Advanced Filter'}
        isOpen={true}
        type={PanelType.medium}
        onDismiss={() => props.onDismiss()}
        isFooterAtBottom={true}
        onRenderFooterContent={() => {
            return <Stack horizontal tokens={{ childrenGap: 10 }}>
                <PrimaryButton text={"Apply"} onClick={() => props.onDismiss(filters)} />
                <DefaultButton text={"Cancel"} onClick={() => { props.onDismiss() }} />
            </Stack>;
        }}>
        <Stack tokens={{ childrenGap: 20 }}>
            
        </Stack>
    </Panel>
};

export default IncomesDashboardFilter;
